export class AssetStatusUpsertModel {
  ApiId: number;
  Status: string;
  Issues: string;
  Column: string[];
}
